export enum ClearanceStatus {
    DRAFT = 'Draft',
    
    // Request Stage
    REQUEST_SUBMITTED = 'Request Submitted',
    REQUEST_ACCEPTED = 'Request Accepted',
    REQUEST_REJECTED = 'Request Rejected',

    // Docs Review Stage
    DOCS_UPLOADED = 'Documents Uploaded',
    DOCS_REVIEW_IN_PROGRESS = 'Docs Review In Progress',
    DOCS_REVIEW_COMPLETED = 'Docs Review Completed',
    DOCS_REVIEW_REJECTED = 'Docs Review Rejected',

    // Customs Filing Stage
    CUSTOMS_FILING_IN_PROGRESS = 'Customs Filing In Progress',
    CUSTOMS_FILING_COMPLETED = 'Customs Filing Completed',
    CUSTOMS_INSPECTION = 'Customs Inspection',

    // Port Handling Stage
    PORT_CHARGES_PENDING = 'Port Charges Pending',
    PORT_CHARGES_PAID = 'Port Charges Paid',
    DELIVERY_ORDER_RECEIVED = 'Delivery Order Received',

    // Delivery Stage
    OUT_FOR_DELIVERY = 'Out for Delivery',
    DELIVERED = 'Delivered',

    // Final Statuses
    COMPLETED = 'Completed',
    CANCELLED = 'Cancelled',
}
